import {documentToReactComponents} from '@contentful/rich-text-react-renderer';

export const renderRichText = (el, renderOptions) => {
  if (el) {
    const textObject = JSON.parse(el.raw);
    return documentToReactComponents(textObject, renderOptions);
  }
  return null;
};
